import SystemNotificationItem from '@app/components/SystemNotificationItem'
import { NotificationContext } from '@app/models/enums'
import { INotificationsContextState } from '@app/models/NotificationsContextState'
import { actionCreators } from '@app/store/modules/systemNotifications'
import { bindFunctions } from '@app/utils/class'
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome'
import classNames from 'classnames'
import * as React from 'react'
import { Link } from 'react-router-dom'
import { Badge, Popover } from 'reactstrap'
import './SystemNotificationsIcon.scss'
import { INotification } from '@app/models/Notification'

export interface ISystemNotificationsIconProps {
  className?: string
  context: NotificationContext
  style?: React.CSSProperties
}

type SystemNotificationsIconProps = ISystemNotificationsIconProps &
  INotificationsContextState &
  typeof actionCreators

export class SystemNotificationsIcon extends React.PureComponent<
  SystemNotificationsIconProps
> {
  constructor(props: SystemNotificationsIconProps) {
    super(props)
    bindFunctions(this)
  }

  public render() {
    const iconPrefix = this.props.unseenCount > 0 ? 'fas' : 'fal'
    const iconName =
      this.props.context === NotificationContext.Calendar
        ? 'calendar'
        : 'globe'
    const iconClasses = classNames({
      'text-primary': this.props.unseenCount > 0,
    })

    const [seen, unseen] = [
      this.props.items.filter((item) => Boolean(item) && item!.seen),
      this.props.items.filter((item) => Boolean(item) && !item!.seen),
    ].map((items) => items.slice(0, 5).toArray())

    return (
      <div
        className={classNames('position-relative', this.props.className)}
        style={this.props.style}
      >
        <a
          id={`${this.props.context}-notifications`}
          onClick={this._toggleOpen}
        >
          <FontAwesomeIcon
            className={iconClasses}
            size='lg'
            icon={[iconPrefix, iconName]}
            fixedWidth
          />
          {this.props.unseenCount > 0 && (
            <Badge
              color='danger'
              style={{
                borderRadius: '0.5rem',
                fontSize: '0.6rem',
                left: '50%',
                position: 'absolute',
              }}
            >
              {this.props.unseenCount > 100 ? '99+' : this.props.unseenCount}
            </Badge>
          )}
        </a>
        <Popover
          className='notifications-popover'
          isOpen={this.props.isOpen}
          placement='bottom'
          target={`${this.props.context}-notifications`}
          toggle={this._toggleOpen}
        >
          <div className='d-flex justify-content-between notifications-popover-header'>
            <div className='font-weight-semi-bold'>Notifications</div>
            <div>
              <a className='text-primary' onClick={this._onMarkAllSeen}>
                Mark all as read
              </a>
            </div>
          </div>
          {this.props.items.size === 0 && (
            <div className='p-2 text-center'>No notifications</div>
          )}
          <div className='notifications-popover-body'>
            {unseen.length > 0 &&
              <>
                <div className='notifications-popover-body-section'>
                  <span className='notifications-popover-body-section-label'>Unseen</span>
                  {unseen.map((item) => (
                    // @ts-expect-error - item may be undefined due to filter operation
                    <SystemNotificationItem item={item} key={item.id} />
                  ))}
                </div>
                {seen.length > 0 &&
                  <hr />
                }
              </>
            }
            {seen.length > 0 &&
              <div className='notifications-popover-body-section'>
                <span className='notifications-popover-body-section-label'>Seen</span>
                {seen.map((item) => (
                  // @ts-expect-error - item may be undefined due to filter operation
                  <SystemNotificationItem item={item} key={item.id} />
                ))}
              </div>
            }
          </div>
          {this.props.items.size > 0 && (
            <div className='notifications-popover-footer text-center'>
              <Link to='/notifications'>See all</Link>
            </div>
          )}
        </Popover>
      </div>
    )
  }

  private _onMarkAllSeen() {
    this.props.markAllSeen(this.props.context)
  }

  private _toggleOpen() {
    this.props.toggleOpen(this.props.context, !this.props.isOpen)
  }
}
